<template>
  <div>
    <div class="with-margin">
      <router-link class="back" to="/"
        ><img alt="Back" src="@/assets/images/back.svg"
      /></router-link>
      <h1>Explore monopolis</h1>
    </div>
    <div class="with-margin tabs">
      <div
        class="flex flex-wrap justify-center floors"
        style="margin-bottom: 89px"
      >
        Map of monopolis
      </div>
    </div>
    <div class="relative">
      <vmap :config="this.monopolis" />
    </div>
  </div>
</template>
<style scoped></style>
<script>
import vmap from "../components/Map";

export default {
  components: { vmap },
  name: "monopolis",
  data() {
    return {
      monopolis: require("../data/monopolis.json")
    };
  },
  methods: {}
};
</script>
